<template lang="pug">
  Popup(
    :visible="visible"
    position="bottom"
    :maskClosable="true"
    @close="handlePopupClose"
  )
    .award-guide-popup-container(:class="{ 'is-mini-tab': isMiniTab }")
      img.award-guide-popup-title(
        src="https://m.hellobike.com/resource/gallery/833/y9Wb16_jR_.png"
        alt=""
      )
      .award-guide-popup-desc 任意完成以下订单，回来领奖励金
      .award-guide-popup-list-area(@touchmove.stop v-scroll-lock="visible")
        .award-guide-popup-list
          template(v-for="(item, index) in list")
            .award-guide-task-item
              .item-left
                SafeImg(className="logo" :src="item.logo")
              .item-right
                .item-name {{ item.title }}
                .item-award-info
                  .award-desc {{ item.guideDesc }}
                  .award-num-area
                    img.coin-icon(
                      src="https://m.hellobike.com/resource/gallery/833/W5VUYJ1L_16x16%EF%BC%883x%EF%BC%89%20(1).png"
                      alt=""
                    )
                    span.num-text +{{ item.actualOfferWorth }}
        .award-guide-popup-list-placeholder
      .award-guide-popup-bottom-container
        .award-guide-popup-vip-entry-area(v-if="extInfo.guidingDesc && extInfo.ariesVip")
          VipEntry(:vipInfo="extInfo")
        .award-guide-popup-btn-area
          .award-guide-popup-btn(@click="handleBtnClick") 知道了
</template>

<script>
import Popup from '@/components/popup.vue';
import SafeImg from '@/components/safe-img.vue';
import VipEntry from './award-vip-entry.vue';

export default {
  name: 'AwardGuidePopup',
  components: { Popup, SafeImg, VipEntry },
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 列表数据
    list: {
      type: Array,
      default: () => [],
    },
    // 扩展信息
    extInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isVip: false,
    };
  },
  computed: {
    // 是否小程序tab页
    isMiniTab() {
      return this.$route.query.isMiniTab === '1';
    },
  },
  mounted() {},
  methods: {
    // 弹层关闭
    handlePopupClose() {
      this.$emit('close');
    },
    // 弹层按钮点击
    handleBtnClick() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.award-guide-popup-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding-top: 0.24rem;
  max-height: 60vh;
  background-image:
    linear-gradient(
      0deg,
      #fff 0%,
      #fff 81%,
      #fff9d2 100%
    );
  border-radius: 0.16rem 0.16rem 0 0;

  .award-guide-popup-title {
    width: 1.75rem;
    height: 0.21rem;
  }

  .award-guide-popup-desc {
    margin-top: 0.08rem;
    font-size: 0.14rem;
    line-height: 0.2rem;
    color: #8e9ca5;
  }

  .award-guide-popup-list-area {
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .award-guide-popup-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 0.08rem;
    padding: 0.17rem 0.22rem 0;
    margin: 0.08rem 0 -0.17rem;
    width: 100%;
    box-sizing: border-box;
  }

  .award-guide-popup-list-placeholder {
    height: 0.17rem;
  }

  .award-guide-task-item {
    display: flex;
    align-items: center;
    margin-bottom: 0.17rem;

    .item-left {
      flex-shrink: 0;

      .logo {
        width: 0.42rem;
        height: 0.42rem;
        overflow: hidden;
        border-radius: 0.12rem;
      }
    }

    .item-right {
      padding-left: 0.04rem;
    }

    .item-name {
      width: 1.2rem;
      font-size: 0.14rem;
      line-height: 0.19rem;
      color: #1f3a4d;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .item-award-info {
      display: flex;
      align-items: center;
      font-size: 0.12rem;
      line-height: 0.19rem;
      color: rgba(31, 58, 77, 0.5);
    }

    .award-desc {
      max-width: 0.5rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .award-num-area {
      display: flex;
      align-items: center;
      // flex-shrink: 0;
      margin-left: 0.05rem;
      padding: 0 0.05rem 0 0;
      height: 0.16rem;
      background-color: #fff8da;
      border-radius: 0.16rem;
    }

    .coin-icon {
      width: 0.16rem;
      height: 0.16rem;
    }

    .num-text {
      margin-left: 0.02rem;
      max-width: 0.67rem;
      font-family: 'DIN Alternate Bold', sans-serif;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: normal;
      font-size: 0.12rem;
      color: #ff3e36;
    }
  }

  .award-guide-popup-btn-area {
    width: 100%;
    padding: 0 0.16rem;
  }

  .award-guide-popup-bottom-container {
    padding-top: 0.14rem;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 0.12rem);
    padding-bottom: calc(env(safe-area-inset-bottom) + 0.12rem);
    width: 100%;

    .is-mini-tab & {
      padding-bottom: 0.9rem;
    }

    .award-guide-popup-vip-entry-area {
      display: flex;
      justify-content: center;
      margin-bottom: 0.15rem;
    }

    .award-guide-popup-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 0.48rem;
      background-color: #ffe888;
      border-radius: 0.08rem;
      color: #000;
      font-weight: 500;
      font-size: 0.16rem;
      line-height: normal;
    }
  }
}
</style>
